import { render, staticRenderFns } from "./TransferGoodsedit.vue?vue&type=template&id=73df1522&scoped=true&"
import script from "./TransferGoodsedit.vue?vue&type=script&lang=js&"
export * from "./TransferGoodsedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73df1522",
  null
  
)

export default component.exports